<template>
  <div v-show='visible'>
  </div>
</template>

<script>

export default {
  name: 'PopupBase',
  components: {
  },
  data () {
    return {
      outside: true,
      visible: false
    };
  },
  mounted () {
    if (this.outside) {
      document.addEventListener('click', (e) => {
        if (this.visible) {
          let path = this.getPath(e);
          if (!path.includes(this.$refs.root)) {
            this.hide();
          }
        }
      });
    }
  },
  methods: {
    show () {
      this.visible = true;
      this.$emit('show', this);
    },
    hide () {
      this.visible = false;
      this.$emit('hide', this);
    },
    onClose () {
      this.hide();
    },
    getPath (e) {
      return e.path || (e.composedPath && e.composedPath());
    }
  }
};

</script>



// WEBPACK FOOTER //
// src/components/PopupBase.vue